import { Button, Col, Form, Input, Row } from 'antd';
import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { resetPassword } from '../../features/user/userSlice'; // Agrega esta acción en tu Redux slice
import { NotificationContext } from '../../providers/NotificationProvider';
import logo from '../../assets/images/logo.png';
import { useTranslation } from 'react-i18next';
import LanguageTabs from '../shared/LanguageTabs';
type FieldType = {
  new_password?: string;
  confirm_password?: string;
};

const ResetPassword: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { uidb64, token } = useParams<{ uidb64: string; token: string }>();
  const { triggerNotification } = useContext(NotificationContext);

  useEffect(() => {
    if (typeof uidb64 === 'undefined' || typeof token === 'undefined') {
      navigate('/'); // Redirige al login si los parámetros uidb64 y token no están presentes
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (values: any) => {
    if (values.new_password.length === 0) {
      triggerNotification('error', t('Error'), t('Por favor ingresa la nueva contraseña.'), 'bottomRight');
      return;
    }

    if (values.new_password !== values.confirm_password) {
      triggerNotification('error', t('Error'), t('Las contraseñas no coinciden'), 'bottomRight');
      return;
    }

    if (typeof uidb64 === 'undefined' || typeof token === 'undefined') {
      return;
    }

    dispatch(resetPassword({ new_password: values.new_password as string, uidb64, token }) as any)
      .then((response: any) => {
        if (resetPassword.fulfilled.match(response)) {
          triggerNotification('success', t('Éxito'), t('Contraseña restablecida correctamente'), 'bottomRight');
          navigate('/');
        } else {
          triggerNotification('error', t('Error'), response.payload.message, 'bottomRight');
        } // Redirige al login
      })
      .catch((err: any) => {
        triggerNotification('error', t('Error'), err.message, 'bottomRight');
      });
  };

  return (
    <div className='home-login'>
      <div style={{ position: 'absolute', top: 16, right: 16 }}>
        <LanguageTabs compact />
      </div>
      <Row>
        <Col className='form-login-container'>
          <img src={logo} alt='logo' className='logo' />
          <Form name='reset' style={{ maxWidth: 600 }} onFinish={handleSubmit} autoComplete='off'>
            <Form.Item<FieldType>
              label={t('Nueva contraseña')}
              name='new_password'
              rules={[{ required: true, message: t('Por favor ingresa la nueva contraseña.') }]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item<FieldType>
              label={t('Confirmar contraseña')}
              name='confirm_password'
              rules={[{ required: true, message: t('Por favor confirma la nueva contraseña.') }]}
            >
              <Input.Password />
            </Form.Item>
            <small>
              {t('Al llenar este formulario estás aceptando las políticas de')}
              <br /> tratamiento de la información que puedes consultar{' '}
              <a target='_blank' href='https://cstrisk.com/privacy-policy/' rel='noreferrer'>
                {t('aquí')}
              </a>
            </small>
            <br />
            <br />
            <Form.Item>
              <Button type='primary' htmlType='submit'>
                {t('Guardar contraseña')}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default ResetPassword;
